import React from "react";
import { useTranslation } from "react-i18next";
import { ClipboardList } from "lucide-react";

interface LogBookToggleButtonProps {
  open: boolean;
  onToggle: () => void;
}

// Копче само со икона во бојата на темата (themed-gradient) за „Вкупно Log Book“.
// Натписот е во tooltip/aria-label; отворена состојба = бел прстен околу копчето.
const LogBookToggleButton: React.FC<LogBookToggleButtonProps> = ({ open, onToggle }) => {
  const { t } = useTranslation();
  const label = open ? t("os.hideTotalProductivity") : t("os.showTotalProductivity");

  return (
    <button
      type="button"
      onClick={onToggle}
      title={label}
      aria-label={label}
      aria-pressed={open}
      className={`themed-gradient inline-flex h-8 w-8 items-center justify-center rounded-md text-white shadow-sm transition-all hover:opacity-90 hover:shadow focus:outline-none focus:ring-2 focus:ring-blue-500/50 dark:focus:ring-blue-600/50 ${
        open ? "ring-2 ring-offset-1 ring-blue-500/50" : ""
      }`}
    >
      <ClipboardList size={16} />
    </button>
  );
};

export default LogBookToggleButton;
